import { render, staticRenderFns } from "./MiniEvent.vue?vue&type=template&id=7247ef20&"
import script from "./MiniEvent.vue?vue&type=script&lang=js&"
export * from "./MiniEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports